<ui-card [loading]="isLoading">
    <app-segment-header title="time-off-v3.policyComponents.carryover.carryover"></app-segment-header>

    <mat-radio-group
        name="topLevelCarryoverSelection"
        class="vertical"
        [(ngModel)]="topLevelCarryoverSelection"
        (ngModelChange)="topLevelCarryoverSelectionChanged()"
    >
        <h4 class="margin-bottom-2">
            {{ 'time-off-v3.policyComponents.carryover.howWouldYouLikeToTreatEmployeesTimeOff' | translate }}
        </h4>
        <div class="flex col">
            <mat-radio-button [value]="carryoverTypes.annualReset">
                <div>{{ 'time-off-v3.policyComponents.carryover.annualReset' | translate }}</div>
                <div class="subscript">
                    {{ 'time-off-v3.policyComponents.carryover.onlyPositiveBalancesWillBeReset' | translate }}
                </div>
            </mat-radio-button>
            <ng-container *ngIf="topLevelCarryoverSelection === carryoverTypes.annualReset">
                <div class="margin-left-2 margin-top-2">
                    <div class="container-card margin-bottom-2">
                        <div>
                            <span>{{
                                'time-off-v3.policyComponents.carryover.employeesBalancesWillBeResetAnnuallyAt'
                                    | translate
                            }}</span>

                            <div class="cap-on-field">
                                <mat-form-field class="no-labels expand-width-input">
                                    <mat-select
                                        name="capOnDate"
                                        #capOnDate
                                        [(ngModel)]="capOnDateVal"
                                        (ngModelChange)="capOnDateChange()"
                                        required
                                    >
                                        <mat-option [value]="capOnOptions.yearEnd"
                                            >{{ 'time-off-v3.policyComponents.carryover.theEndOfTheYear' | translate }}
                                        </mat-option>
                                        <mat-option [value]="capOnOptions.dateHired"
                                            >{{
                                                'time-off-v3.policyComponents.carryover.employeesHireDateAnniversary'
                                                    | translate
                                                    | lowercase
                                            }}
                                        </mat-option>
                                        <mat-option [value]="capOnOptions.pickDate"
                                            >{{
                                                'time-off-v3.policyComponents.carryover.pickADate'
                                                    | translate
                                                    | lowercase
                                            }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <ng-container *ngIf="capOnDate?.value === capOnOptions.pickDate">
                                    <mat-form-field class="no-labels restricted-width-input margin-left-1">
                                        <mat-select
                                            name="month"
                                            placeholder="{{ 'time-off-v3.month' | translate }}"
                                            [(ngModel)]="carryoverMonth"
                                            (ngModelChange)="updateCarryoverDate()"
                                            required
                                        >
                                            <mat-option *ngFor="let month of months" [value]="month.value">{{
                                                month.label
                                            }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="no-labels restricted-width-input margin-left-1">
                                        <mat-select
                                            name="day"
                                            placeholder="{{ 'time-off-v3.day' | translate }}"
                                            [(ngModel)]="carryoverDay"
                                            (ngModelChange)="updateCarryoverDate()"
                                            required
                                        >
                                            <mat-option *ngFor="let day of daysInMonth" [value]="day">{{
                                                day > 0 ? (day | ordinalNumber) : ('time-off-v3.lastDay' | translate)
                                            }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <mat-radio-button [value]="carryoverTypes.carryOver">
                <div>{{ 'time-off-v3.policyComponents.carryover.carryoverUnusedBalance' | translate }}</div>
                <div class="subscript">
                    {{ 'time-off-v3.policyComponents.carryover.employeesCanCarryOverTheirTimeOff' | translate }}
                </div>
            </mat-radio-button>
        </div>
    </mat-radio-group>

    <ng-container *ngIf="topLevelCarryoverSelection === carryoverTypes.carryOver">
        <div class="margin-left-2 margin-top-2">
            <mat-radio-group
                name="subLevelCarryoverSelection"
                class="vertical"
                [(ngModel)]="subLevelCarryoverSelection"
                (ngModelChange)="subLevelCarryoverSelectionChanged()"
            >
                <div class="flex col">
                    <mat-radio-button class="margin-bottom-1" [value]="carryoverSubTypes.limitedCarryover">
                        <div>{{ 'time-off-v3.policyComponents.carryover.limitedCarryover' | translate }}</div>
                        <div class="subscript">
                            {{
                                'time-off-v3.policyComponents.carryover.employeesHaveLimitsOnTHeirYearEndBalancesCarrying'
                                    | translate
                            }}
                        </div>
                    </mat-radio-button>

                    <ng-container *ngIf="subLevelCarryoverSelection === carryoverSubTypes.limitedCarryover">
                        <div class="container-card limited-carryover">
                            <div>
                                <span>{{
                                    'time-off-v3.policyComponents.carryover.employeesCanCarryOverAMaximumOf' | translate
                                }}</span>

                                <mat-form-field class="no-labels restricted-width-input margin-left-1 margin-right-1">
                                    <input
                                        name="carryoverAmount"
                                        matInput
                                        [min]="0.1"
                                        [textMask]="{ mask: numberMask }"
                                        placeholder="0"
                                        [ngModel]="timeOffPolicy.getLocalizedProperty('carryoverCap')"
                                        (ngModelChange)="
                                            timeOffPolicy.setLocalizedProperty('carryoverCap', $event); onChange.emit()
                                        "
                                        required
                                        #carryOverAmount="ngModel"
                                    />
                                    @if (timeOffPolicy) {
                                        <span matSuffix>{{
                                            timeOffPolicy.timeOffType.unitOfTimePluralTranslation
                                                | translate
                                                | lowercase
                                        }}</span>
                                    }

                                    <mat-error *ngIf="carryOverAmount.invalid">{{
                                        carryOverAmount.errors | formErrors
                                    }}</mat-error>
                                </mat-form-field>

                                <span>{{ 'time-off-v3.policyComponents.carryover.toTheNextYearAt' | translate }}</span>

                                <div class="cap-on-field">
                                    <mat-form-field class="expand-width-input no-labels">
                                        <mat-select
                                            name="capOnDate"
                                            #capOnDate
                                            [(ngModel)]="capOnDateVal"
                                            (ngModelChange)="capOnDateChange()"
                                            required
                                        >
                                            <mat-option [value]="capOnOptions.yearEnd"
                                                >{{
                                                    'time-off-v3.policyComponents.carryover.theEndOfTheYear' | translate
                                                }}
                                            </mat-option>
                                            <mat-option [value]="capOnOptions.dateHired"
                                                >{{
                                                    'time-off-v3.policyComponents.carryover.employeesHireDateAnniversary'
                                                        | translate
                                                        | lowercase
                                                }}
                                            </mat-option>
                                            <mat-option [value]="capOnOptions.pickDate"
                                                >{{
                                                    'time-off-v3.policyComponents.carryover.pickADate'
                                                        | translate
                                                        | lowercase
                                                }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <ng-container *ngIf="capOnDate?.value === capOnOptions.pickDate">
                                        <mat-form-field class="no-labels restricted-width-input margin-left-1">
                                            <mat-select
                                                name="month"
                                                placeholder="{{ 'time-off-v3.month' | translate }}"
                                                [(ngModel)]="carryoverMonth"
                                                (ngModelChange)="updateCarryoverDate()"
                                                required
                                            >
                                                <mat-option *ngFor="let month of months" [value]="month.value">{{
                                                    month.label
                                                }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="no-labels restricted-width-input margin-left-1">
                                            <mat-select
                                                name="day"
                                                placeholder="{{ 'time-off-v3.day' | translate }}"
                                                [(ngModel)]="carryoverDay"
                                                (ngModelChange)="updateCarryoverDate()"
                                                required
                                            >
                                                <mat-option *ngFor="let day of daysInMonth" [value]="day">{{
                                                    day > 0
                                                        ? (day | ordinalNumber)
                                                        : ('time-off-v3.lastDay' | translate)
                                                }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                </div>
                            </div>

                            <div>
                                <span>{{
                                    'time-off-v3.policyComponents.carryover.unitOfTimeCarriedOverFromThePreviousYearWillExpireAfter'
                                        | translate
                                            : {
                                                  unit:
                                                      timeOffPolicy.timeOffType.unitOfTimePluralTranslation
                                                      | translate
                                                      | capitalize,
                                              }
                                }}</span>

                                <mat-form-field class="no-labels restricted-width-input margin-left-1 margin-right-1">
                                    <input
                                        name="carryoverExpireAfter"
                                        matInput
                                        [textMask]="{ mask: numberMask }"
                                        [ngModel]="timeOffPolicy.getLocalizedProperty('carryoverExpireAfter')"
                                        (ngModelChange)="
                                            timeOffPolicy.setLocalizedProperty('carryoverExpireAfter', $event);
                                            onChange.emit()
                                        "
                                        #carryoverExpireAfter="ngModel"
                                    />
                                    <span matSuffix>{{ 'time-off-v3.days' | translate | lowercase }}</span>
                                    <mat-error *ngIf="carryoverExpireAfter.invalid">{{
                                        carryoverExpireAfter.errors | formErrors
                                    }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>

                    <mat-radio-button class="margin-bottom-1" [value]="carryoverSubTypes.unlimitedCarryover">
                        <div>{{ 'time-off-v3.policyComponents.carryover.unlimitedCarryover' | translate }}</div>
                        <div class="subscript">
                            {{
                                'time-off-v3.policyComponents.carryover.employeesCanCarryTheirEntireTimeOffBalances'
                                    | translate
                            }}
                        </div>
                    </mat-radio-button>
                </div>
            </mat-radio-group>
        </div>
    </ng-container>
</ui-card>
